/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";
import ProfilesList from "examples/Lists/ProfilesList";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";

// Overview page components
import Header from "layouts/profile/components/Header";
import PlatformSettings from "layouts/profile/components/PlatformSettings";

// Data
import profilesListData from "layouts/profile/data/profilesListData";

// Images
import temp from "assets/images/nastuh.jpg";

function Overview() {
  const [user, setUser] = useState(null);
  useEffect(() => {
    try {
      // Safely parse user data from localStorage
      const userRaw = localStorage.getItem("user");
      const user = userRaw ? (typeof userRaw === "object" ? userRaw : JSON.parse(userRaw)) : null;
      console.log("Profile page user data:", user);

      if (!user) {
        console.error("No user data found in localStorage");
        return;
      }

      const sub = user.sub;

      if (sub) {
        fetch("https://int.api.chefaicookware.com/users-service/users/dashboard/sub", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ sub }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Success:", data);
            setUser(data);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      } else {
        console.error("Error: No sub found in user object");
      }
    } catch (error) {
      console.error("Error processing user data:", error);
    }
  }, []);
  return (
    <>
      {user && (
        <DashboardLayout>
          <DashboardNavbar />
          <MDBox mb={2} />
          <Header username={user.name} thumbnail={user.picture}>
            <MDBox mt={5} mb={3}>
              <Grid container spacing={1}>
                <Grid item xs={12} md={6} xl={4}>
                  <PlatformSettings />
                </Grid>
                <Grid item xs={12} md={6} xl={4} sx={{ display: "flex" }}>
                  <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
                  <ProfileInfoCard
                    title="profile details"
                    info={{
                      name: user.name,
                      email: user.email,
                    }}
                    action={{ route: "", tooltip: "Edit Profile" }}
                    shadow={false}
                  />
                  <Divider orientation="vertical" sx={{ mx: 10 }} />
                </Grid>
                <Grid item xs={12} xl={4}>
                  <ProfilesList title="favorite recipes" shadow={false} />
                </Grid>
              </Grid>
            </MDBox>
            <MDBox pt={2} px={2} lineHeight={1.25}>
              <MDTypography variant="h6" fontWeight="medium">
                Service Subscriptions
              </MDTypography>
              <MDBox mb={1}>
                <MDTypography variant="button" color="text">
                  Extra Features
                </MDTypography>
              </MDBox>
            </MDBox>
            <MDBox p={2}>
              <Grid container spacing={6}>
                <Grid item xs={12} md={6} xl={3}>
                  <DefaultProjectCard
                    image={temp}
                    label="Health"
                    title="Calorie Tracking"
                    description="Track your calories and macros from food you have cooked in your FRY-AI"
                    action={{
                      type: "internal",
                      route: "/profile",
                      color: "info",
                      label: "view subscription",
                    }}
                  />
                </Grid>
              </Grid>
            </MDBox>
          </Header>
          <Footer />
        </DashboardLayout>
      )}
    </>
  );
}

export default Overview;
